export default {
	root: 'https://wissenmap.hartung.dev'
}
